<template>
  <div>
    <van-dialog v-model="close" :show-confirm-button="false" width="281px">
      <div class="crossClose">
        <van-icon name="cross" @click="onCancel()" />
      </div>
      <div class="content">
        <div class="imgBox">
          <div class="imgTop">
            <div class="exclamatory">
              <img src="../../../assets/images/exclamatory.png" alt="" />
            </div>
          </div>
        </div>

        <div class="message">账户信息有误</div>
        <div slots="footer">
          <div class="buttonText">
            <button class="button" @click="onSubmit()">确定</button>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Dialog, Overlay, Empty, Icon, Toast } from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/bank/index";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay,
    [Empty.name]: Empty,
    [Icon.name]: Icon,
    [Toast.name]: Toast
  },
  data() {
    return {
      show: true,
      close: true,
      rejectReasons:
        "您的账户信息未绑定，请前去修改您的信息，否则工资将不能够准时发放！"
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankCardStatus"])
  },
  mounted() {
    // this.init(this.$route.query.getStatus);
  },

  methods: {
    ...mapActions(["saveBankStatus"]),
    onCancel() {
      this.close = false;
    },
    // 判断是否第一次进入
    // init(getStatus) {
    //   // 查询银行卡状态 未绑定 通过 未通过
    //   service.getStatus().then((res) => {
    //     if (res.data == "未绑定") {
    //       // this.close = true;
    //       Dialog.alert({
    //         title: "提示",
    //         message: this.rejectReasons
    //       }).then(() => {
    //         // on confirm
    //         this.$router.replace({
    //           name: "addBankCard",
    //           query: {
    //             IsBankCardShow: false
    //           }
    //         });
    //       });
    //     }
    //     if (res.data == "通过") {
    //       this.$emit("IsShowToast", false);
    //     }
    //     if (res.data == "未通过") {
    //       Dialog.alert({
    //         title: "提示",
    //         message: "信息有误"
    //       }).then(() => {
    //         // on confirm
    //         this.$router.replace({
    //           name: "detailBankCard",
    //           query: {
    //             IsShow: true
    //           }
    //         });
    //       });
    //     }
    //   });
    //   // Dialog.alert({
    //   //   title: "提示",
    //   //   message: this.rejectReasons
    //   // }).then(() => {
    //   //   // on confirm
    //   //   this.$router.replace("detailBankCard");
    //   // });
    // }
    // 如果银行信息有误 调这个接口跳到银行卡详情页面 解绑
    onSubmit() {
      this.close = false;

      service
        .getReject()
        .then((res) => {
          if (res.statusCode == 200) {
            // 驳回原因在银行详情显示
            this.$router.push({
              name: "detailBankCard"
            });
            let obj = {
              save: true,
              cardStatus: true,
              IsShow: true,
              color:
                this.bankCardStatus !== null && this.bankCardStatus.color
                  ? this.bankCardStatus.color
                  : 0
            };
            this.saveBankStatus(obj);
          } else {
            Toast(res.errors);
            // false 显示银行卡信息
            this.$router.push({
              name: "addBankCard"
            });
          }
          // 说明银行卡还未绑定 跳转到添加银行卡页面 不展示银行信息
        })
        .catch((err) => {
          Toast(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.crossClose {
  float: right;
  width: 30px;
  height: 40px;
  line-height: 40px;
}
.content {
  width: 281px;
  height: 162px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .imgBox {
    width: 33px;
    height: 27px;
    border: 3px solid;
    border-radius: 6px;
  }
  .imgTop {
    margin-top: 5px;
    border-top: 3px solid;
  }
  .exclamatory {
    width: 18px;
    height: 18px;
    margin: auto;
  }
  .button {
    width: 90px;
    height: 36px;
    border-radius: 5px;
  }
  .message {
    margin-top: 20px;
  }
}
</style>